import React, {useState} from "react"
import * as Yup from "yup"
import {useForm} from "react-hook-form"
import {useSelector} from "react-redux";
import {Button, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"


// labels
import {REQUIRED} from "../../../components/i18n/i18n"

// utils
import {getStateByPath} from "../../../redux/selectors";

// services
import {activityService} from "../../../jwt/_services/core/activityService";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import useParamSetting from "../../../hooks/useParamSetting";



const NotifyForm = props => {
    const { path, lang, title, body, allotment, activity } = props

    const componentState = useSelector(state => getStateByPath(state, path));
    const { app:{ fbDataBase } } = componentState?.data || {};


    const { paramSetting = {}, loading } = useParamSetting('notification_max_character', true)
    const notificationConfig = JSON.parse(paramSetting?.ps_value_max || '{}')


    const [totalCharactersInTitle, setTotalCharactersInTitle] = useState(title?.length || 0)
    const [totalCharactersInBody, setTotalCharactersInBody] = useState(body?.length || 0)


    const validationSchema = Yup.object().shape({
        title: Yup.string().required( REQUIRED ).max(notificationConfig?.title, "El título no puede tener más de 29 caracteres"),
        body: Yup.string().required( REQUIRED ).max(notificationConfig?.body, "El contenido no puede tener más de 83 caracteres"),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            title: title,
            body: body,
        }
    });


    const onSubmit = (data, _) => {
        const responseData = {
            fbDataBase: {id: fbDataBase?.id},
            item : {
                idActivity:activity?.id,
                notificationType: 'ALLOTMENT',
                allotment,
                lang: lang?.id,
                ...data
            }
        }
        
        genericIndexedActions.notify(path, activityService, responseData)
    };

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Row>
            <Col>
                <FormGroup>
                    <Label>{'Título de la notificación'}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={'Título de la notificación'}
                        className={(errors.title ? ' is-invalid' : '')}
                        maxLength={notificationConfig?.title}
                        onChange={e => setTotalCharactersInTitle(e.target.value.length)}
                        innerRef={register}
                    />
                    <div className={`pull-right ${errors.title || notificationConfig?.title === totalCharactersInTitle && 'label-is-invalid'}`}>
                        { !loading && <> {totalCharactersInTitle} / {notificationConfig?.title}  </> }
                    </div>
                    {errors.title && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.title?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col>
                <FormGroup>
                    <Label>{'Contenido de la notificación'}</Label>
                    <Input
                        type="textarea"
                        name="body"
                        placeholder={'Contenido de la notificación'}
                        className={(errors.body ? ' is-invalid' : '')}
                        maxLength={notificationConfig?.body}
                        onChange={e => setTotalCharactersInBody(e.target.value.length)}
                        innerRef={register}
                    />
                    <div className={`pull-right ${errors.body || notificationConfig?.body === totalCharactersInBody && 'label-is-invalid'}`}>
                        { !loading && <> {totalCharactersInBody} / {notificationConfig?.body}  </> }
                    </div>
                    {errors.body && <div className="invalid-feedback" style={{'display': 'block'}}>{errors?.body?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col>
            <center>
                    <Button color={'primary'} type={'submit'} className={'btn btn-lg'}>
                        <i className="fa fa-paper-plane" aria-hidden="true"/> Enviar Notificación ({lang?.name})
                    </Button>
                </center>
            </Col>
        </Row>
    </Form>
}
export default NotifyForm